const pickSkeletonColor = themeName => {
	if (themeName === 'white')
		return { backgroundColor: '#d5d5d5', foregroundColor: '#ccc' };
	// return { backgroundColor: '#f7f8fa', foregroundColor: '#fff' };
	else if (themeName === 'black')
		return { backgroundColor: '#272c34', foregroundColor: '#2e343d' };
	else if (themeName === 'ocean')
		return { backgroundColor: '#023a58', foregroundColor: '#033e5d' };
	else if (themeName === 'viola')
		return { backgroundColor: '#45315c', foregroundColor: '#513a6b' };
};

export default pickSkeletonColor;
